module.exports = __webpack_public_path__ + "ptc_nakagawa_T1.8597ec1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_T1.jpg
// module id = Ha0C
// module chunks = 0